<div *ngIf="cardInfo" class="activity-card-meeting">
  <mat-card class="bottom-card">
    <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
      <div matCardAvatar *ngIf="showAvatar">
        <glxy-avatar
          [width]="AVATAR_WIDTH"
          icon="calendar_today"
          backgroundColor="var(--primary-background-color)"
          textColor="#9E9E9E"
        ></glxy-avatar>
      </div>
      <mat-card-title>
        <span *ngIf="headerText$() | async as headerText; else loadingHeaderText" class="title">
          {{ headerText }}
        </span>
        <ng-template #loadingHeaderText>
          <span class="loading-header-text stencil-shimmer"></span>
        </ng-template>
      </mat-card-title>
      <mat-card-subtitle>
        <p *ngIf="cardInfo.date !== null" class="effective-date">
          {{ cardInfo.date | date: dateFormat }}
        </p>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 16).toString() + 'px'">
      <mat-card appearance="outlined" class="inner-card">
        <mat-card-title *ngIf="!cardInfo.meetingSummaryTitle" class="mat-card-title meeting-title">
          <span *ngIf="cardTitle() as cardTitle">{{ cardTitle }}</span>
        </mat-card-title>

        <mat-card-content [style.margin-left]="-(AVATAR_WIDTH - 36).toString() + 'px'">
          @if (cardInfo.meetingSummaryBody || cardInfo.meetingSummaryTitle) {
            <div *ngIf="cardInfo.meetingSummaryTitle" class="meeting-summary-title">
              <div [innerHTML]="cardInfo.meetingSummaryTitle" class="summary-title"></div>
            </div>

            <div class="summarized-by-ai" *ngIf="cardInfo.meetingSummaryBody">
              <div class="summary-by-ai">
                <mat-icon class="ai-icon" svgIcon="galaxy-ai-icon" />
                <div>{{ 'ACTIVITY.MEETING.SUMMARY_BY_AI' | translate }}</div>
              </div>
              <div class="meeting-summary-body">
                <span [innerHTML]="cardInfo.meetingSummaryBody"></span>
              </div>
              <a data-action="”view-summary-link-clicked”" class="view-summary-link" (click)="openSummaryModal()">{{
                'ACTIVITY.MEETING.MEETING_ANALYSIS.VIEW_SUMMARY' | translate
              }}</a>
            </div>
          } @else {
            <div *ngIf="cardInfo.meetingBody">
              <crm-collapsible-section [maxHeightPx]="100">
                <span class="meeting-body" [innerHTML]="cardInfo.meetingBody"></span>
              </crm-collapsible-section>
            </div>
          }

          <div class="row meeting-details">
            <ng-container
              [ngTemplateOutlet]="activityData"
              [ngTemplateOutletContext]="{ label: 'ACTIVITY.DATE', value: cardInfo.date | date: dateFormat }"
            ></ng-container>
            <ng-container
              *ngIf="cardInfo.meetingDuration"
              [ngTemplateOutlet]="activityData"
              [ngTemplateOutletContext]="{ label: 'ACTIVITY.DURATION', value: cardInfo.meetingDuration }"
            ></ng-container>
            <ng-container
              *ngIf="cardInfo.meetingSalesScore"
              [ngTemplateOutlet]="activityData"
              [ngTemplateOutletContext]="{
                label: 'ACTIVITY.MEETING.SALES_SCORE',
                value: cardInfo.meetingSalesScore + '/10',
              }"
            ></ng-container>
            <ng-container
              *ngIf="!cardInfo.meetingSummarySentiment"
              [ngTemplateOutlet]="activityData"
              [ngTemplateOutletContext]="{ label: 'ACTIVITY.STATUS', value: cardInfo.meetingStatus }"
            ></ng-container>
            <ng-container
              *ngIf="cardInfo.meetingLocation"
              [ngTemplateOutlet]="activityData"
              [ngTemplateOutletContext]="{ label: 'ACTIVITY.LOCATION', value: cardInfo.meetingLocation }"
            ></ng-container>
            <ng-container
              *ngIf="cardInfo.meetingSummarySentiment"
              [ngTemplateOutlet]="activityData"
              [ngTemplateOutletContext]="{
                label: 'ACTIVITY.MEETING.SENTIMENT_SCORE',
                value: cardInfo.meetingSummarySentiment + '/10',
              }"
            ></ng-container>
          </div>
          <crm-association-popover [hideDivider]="true"></crm-association-popover>
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #activityData let-label="label" let-value="value">
  <div class="col col-xs-12 col-md-3">
    <div class="activity-data-label">
      {{ label | translate }}
    </div>
    <div class="activity-data-value">
      <!-- ng-container necessary so angular interpolation will add empty -->
      <ng-container *ngIf="value">
        {{ value }}
      </ng-container>
    </div>
  </div>
</ng-template>
